// extracted by mini-css-extract-plugin
export default {"miniBioContainer":"style_miniBioContainer__tBSmN","miniBio":"style_miniBio__EtlTU","rowC":"style_rowC__nC3TE"};